/* ---------------------------------------------------------
   Variant Thumbnail Filter for Dawn 15.4.1 (Thumbnail layout)
   --------------------------------------------------------- */

console.log("Custom variant thumbnail filter loaded for Dawn thumbnails layout");

/* Normalize color text */
function normalize(text) {
  return String(text || "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
}

/* Extract color name from alt text */
function extractColorFromAlt(alt) {
  if (!alt) return "";
  let part = alt.split("-").pop().split("|").pop().trim().toLowerCase();
  return normalize(part);
}

/* Filter thumbnails ONLY */
function filterThumbnails(selectedColor) {
  const colorNorm = normalize(selectedColor);
  console.log("Filtering thumbnails for:", colorNorm || "(none)");

  const thumbs = document.querySelectorAll(".thumbnail-list__item");

  thumbs.forEach((thumb) => {
    const img = thumb.querySelector("img");
    if (!img) return;

    const altColor = extractColorFromAlt(img.alt);

    /* Show only thumbnails that match */
    thumb.style.display = altColor.includes(colorNorm) ? "" : "none";
  });
}

/* Activate the corresponding main image slide */
function activateMatchingSlide(selectedColor) {
  const match = Array.from(document.querySelectorAll(".thumbnail-list__item"))
    .find(t => t.style.display !== "none");

  if (!match) return;

  const target = match.getAttribute("data-target");
  const slide = document.querySelector(`[data-media-id="${target}"]`);
  if (!slide) return;

  // Tell Dawn to skip its own media switching once
  window.SKIP_SHOPIFY_MEDIA_SWITCH = true;

  /* Remove active class */
  document.querySelectorAll(".product__media-item").forEach(s =>
    s.classList.remove("is-active")
  );

  /* Add active to matched slide */
  slide.classList.add("is-active");

  slide.scrollIntoView({ behavior: "smooth", block: "nearest" });
}

/* Run both thumbnail filtering + main image switching */
function runFilter() {
  const colorInput = document.querySelector(
    'input[type="radio"][name*="Color"]:checked'
  );
  if (!colorInput) return;

  const selectedColor = colorInput.value;

  filterThumbnails(selectedColor);
  activateMatchingSlide(selectedColor);
}

/* Initialize on page load */
document.addEventListener("DOMContentLoaded", () => {
  runFilter();
});

/* When a color swatch is clicked */
document.addEventListener("change", (event) => {
  if (event.target.matches('input[name*="Color"]')) {
    runFilter();
  }
});

/* ---------------------------------------------------------
   FIX COLOR PICKER LABEL RESETTING
   (prevents Dawn from reverting label to "Black")
---------------------------------------------------------- */
document.addEventListener("change", function (e) {
  if (e.target.matches('input[name*="Color"]')) {
    const val = e.target.value.trim();
    const legend = document.querySelector('.product-form__input--swatch legend [data-selected-value]');
    if (legend) legend.textContent = val;
  }
});

document.addEventListener("DOMContentLoaded", () => {
  // Ensure first visible thumbnail is marked active on load
  const firstVisibleThumb = Array.from(
    document.querySelectorAll(".thumbnail-list__item")
  ).find(t => t.style.display !== "none");

  if (!firstVisibleThumb) return;

  // Clear any existing active state
  document
    .querySelectorAll('.thumbnail-list__item button[aria-current="true"]')
    .forEach(btn => btn.removeAttribute("aria-current"));

  const btn = firstVisibleThumb.querySelector("button");
  if (btn) {
    btn.setAttribute("aria-current", "true");
  }
});

